import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { RouteMeta } from '../content/tools';
import { toolIcon } from '../content/toolIcons';
import './ToolCard.css';

interface ToolCardProps {
  route: RouteMeta;
  /**
   * Heading level for the tool name. The tools index makes each card an h2
   * because the cards are the page's structure; the homepage uses h3 because
   * they sit under a section heading.
   */
  headingLevel?: 2 | 3;
}

/**
 * One tool, as a card: glyph, name, one-line summary and a whole-card link.
 *
 * Shared by the homepage and the tools index so the two lists cannot drift, and
 * so a new entry in tools.json needs no markup anywhere.
 */
const ToolCard: React.FC<ToolCardProps> = ({ route, headingLevel = 2 }) => {
  const Heading = (`h${headingLevel}` as unknown) as React.ElementType;

  return (
    <article className="tool-card">
      <span className="tool-card__icon" aria-hidden="true">
        <FontAwesomeIcon icon={toolIcon(route.slug)} />
      </span>
      <Heading className="tool-card__name">
        {/* The whole card is the hit area; the ::after below stretches this
            link over it, so there is still exactly one link per card. */}
        <Link className="tool-card__link" to={route.path}>
          {route.h1}
        </Link>
      </Heading>
      <p className="tool-card__summary">{route.shortDescription}</p>
      <span className="tool-card__cue" aria-hidden="true">
        <FontAwesomeIcon icon={faArrowRight} />
      </span>
    </article>
  );
};

export default ToolCard;
